// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Styles custom
import './scss/pages/offers.all.scss'

// Offers Map
async function getOffersMap ($f) {
  import(/* webpackChunkName: "offersMap", webpackPrefetch: true */ './js/components/offersMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Filter Form
async function getOfForm ($f) {
  import(/* webpackChunkName: "offersFilterForm", webpackPrefetch: true */ './js/components/offersFilterForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Autocomplete
async function getOffersAutocomplete ($f) {
  import(/* webpackChunkName: "offersAutocomplete" */ './js/components/offersAutocomplete.js').then(module => {
    module.offersAutocomplete.init($f)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // alertes bootstrap
  const $g = $('.alert')
  if ($g.length) {
    $g.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des terrains
    const $a = $('#map-offers')
    const $b = $('#map-detail')
    if ($a.length) {
      $a.waypoint(function () {
        $a.load()
        getOffersMap($a)
        this.destroy()
      }, {
        offset: '100%'
      })
    } else if ($b.length) {
      $b.waypoint(function () {
        $b.load()
        getOffersMap($b)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })

  // filtres des offres autocomplete
  $('form[name="ofForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getOffersAutocomplete($(this).parents('form'))
  })

  // gestion des filtres des offres
  const $c = $('form[name="ofForm"]')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getOfForm($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#header').height() - 50)
    }, 300)
  }

  const $mn = $('#main-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })

  // gestion des scrollbars améliorées
  const $l = $('.custom-lists')
  if ($l.length) {
    $l.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // collapsing content for exploration links
  $('#collapsing-me').on('click', function () {
    const $c = $('#collapsing')
    $c.toggleClass('close')
    if ($c.hasClass('close')) { $(this).html('+') } else { $(this).html('-') }
  })
})
